export default __webpack_public_path__ + "static/media/woocommerce.3be94200.svg";